import React from 'react';
import { Button } from 'react-bootstrap';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

export default function PaginationControls({
  page = 1,
  hasPrev = false,
  hasNext = false,
  onPrev,
  onNext,
}) {
  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3">
      <div className="small text-muted">Page {page}</div>

      <div className="d-flex gap-2">
        <Button
          size="sm"
          variant="outline-secondary"
          disabled={!hasPrev}
          onClick={onPrev}
          style={{ cursor: hasPrev ? 'pointer' : 'not-allowed' }}
        >
          <FiChevronLeft className="me-1" />
          Previous
        </Button>

        <Button
          size="sm"
          variant="outline-secondary"
          disabled={!hasNext}
          onClick={onNext}
          style={{ cursor: hasNext ? 'pointer' : 'not-allowed' }}
        >
          Next
          <FiChevronRight className="ms-1" />
        </Button>
      </div>
    </div>
  );
}